import React from 'react';
import styled from 'styled-components';
import { ellipsis, textMuted } from '../modules/Styles';
import CardTitleLogo from '../elements/CardTitleLogo';
var cardTitleLogoHeight = 50;
var CardTitleBlockInner = styled.div.withConfig({
  displayName: "CardTitleBlock__CardTitleBlockInner",
  componentId: "sc-1udjz5e-0"
})(["height:", "px;"], cardTitleLogoHeight);
var CardTitleLogoContainer = styled.div.withConfig({
  displayName: "CardTitleBlock__CardTitleLogoContainer",
  componentId: "sc-1udjz5e-1"
})(["float:", ";height:", "px;max-width:40%;"], function (_ref) {
  var logoOnRight = _ref.logoOnRight;
  return logoOnRight ? 'right' : 'left';
}, cardTitleLogoHeight);
var CardTitleLogoHelper = styled.div.withConfig({
  displayName: "CardTitleBlock__CardTitleLogoHelper",
  componentId: "sc-1udjz5e-2"
})(["height:100%;display:inline-block;vertical-align:middle;"]);
var CardTitle = styled.h4.withConfig({
  displayName: "CardTitleBlock__CardTitle",
  componentId: "sc-1udjz5e-3"
})(["text-align:", ";color:#3c637c;line-height:", "px;margin-top:0;margin-bottom:0;", " font-family:inherit;font-weight:bold;font-size:2rem;"], function (_ref2) {
  var logoOnRight = _ref2.logoOnRight;
  return logoOnRight ? 'left' : 'right';
}, cardTitleLogoHeight, ellipsis());
var CardSubtitle = styled.h6.withConfig({
  displayName: "CardTitleBlock__CardSubtitle",
  componentId: "sc-1udjz5e-4"
})(["", " ", " max-height:18px;font-weight:400;font-family:inherit;"], ellipsis(), textMuted());

var CardTitleBlock = function CardTitleBlock(_ref3) {
  var logoOnRight = _ref3.logoOnRight,
      logoSrc = _ref3.logoSrc,
      subtitle = _ref3.subtitle,
      title = _ref3.title;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CardTitleBlockInner, null, /*#__PURE__*/React.createElement(CardTitleLogoContainer, {
    logoOnRight: logoOnRight
  }, /*#__PURE__*/React.createElement(CardTitleLogoHelper, null), /*#__PURE__*/React.createElement(CardTitleLogo, {
    src: logoSrc
  })), /*#__PURE__*/React.createElement(CardTitle, {
    logoOnRight: logoOnRight
  }, title)), /*#__PURE__*/React.createElement(CardSubtitle, null, subtitle));
};

CardTitleBlock.defaultProps = {
  logoOnRight: true
};
export default CardTitleBlock;